import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EpicrisisEntity, ServicioEpicrisisService, EpicrisisInformacionAfiliado, EpicrisisCuerpo } from '../../services/servicio-epicrisis.service';
import { ImagesService } from '../../services/utils/images.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ServicioEntidadService, EntidadEmpresarialEntity } from '../../services/servicio-entidad.service';
import { ServicioAuthService } from '../../services/servicio-auth.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-reporte-epicrisis',
  templateUrl: './reporte-epicrisis.component.html',
  styleUrls: ['./reporte-epicrisis.component.css']
})
export class ReporteEpicrisisComponent implements OnInit {

  loading: boolean;

  firmaProfesional: string;
  logo: string;
  mensajeError: string;
  mensajeLoading: string;
  usuario: string;

  fechaImpresion: Date;

  entidadEmpresarial: EntidadEmpresarialEntity;
  informacionAfiliado: EpicrisisInformacionAfiliado;
  informacionEpicrisis: EpicrisisCuerpo[];
  objectEpicrisis: EpicrisisEntity = {};
  profesional: { unco: number, nombreCompleto: string, registro: string; especialidad: string; };

  constructor(private activatedRoute: ActivatedRoute,
              private servicioImagenes: ImagesService,
              private servicioEntidad: ServicioEntidadService,
              private servicioEpicrisis: ServicioEpicrisisService,
              private servicioAuth: ServicioAuthService,
              private titleService: Title) {
    this.activatedRoute.params.subscribe(params => {
      this.objectEpicrisis.codigo = params['codigoBaseDatos'];
      this.objectEpicrisis.uncoSede = Number(params['uncoSede']);
      this.objectEpicrisis.uncoLogin = Number(params['uncoLogin']);
      this.objectEpicrisis.uncoHistoria = Number(params['uncoHistoria']);
    });
  }

  ngOnInit() {
    this.titleService.setTitle('Reporte Epicrisis - Standard Health');
  }

  onFiltrosCompletados(obj: EpicrisisEntity) {
    this.fechaImpresion = new Date();
    this.objectEpicrisis = obj;
    this.usuario = this.servicioAuth.getUsuarioToken();
    this.profesional = null;
    this.mensajeError = null;
    this.mensajeLoading = null;
    this.getLogo();
  }

  async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información del logo entidad ...';
      const response = await this.servicioImagenes.getLogo(this.objectEpicrisis.codigo);
      response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteEpicrisis.getLogo()', err);
        this.logo = null;
        this.mensajeLoading = null;
        this.mensajeError = 'Error al obtener información del logo entidad, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.';
      });
    } catch (e) {
      console.error('Catch ReporteEpicrisis.getLogo()', e);
      this.logo = null;
      this.mensajeLoading = null;
      this.mensajeError = 'Error grave al obtener información del logo entidad, intente de nuevo o reporte caso al administrador.';
    }
  }

  async getEntidadEmpresarial() {
    try {
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.objectEpicrisis.codigo, this.objectEpicrisis.uncoSede);
      response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {
          this.entidadEmpresarial = data[0];
          this.getInformacionAfiliado();
        } else {
          this.entidadEmpresarial = null;
          this.mensajeLoading = null;
          this.mensajeError = 'Error al obtener información de la entidad empresarial, verifique configuración de sede y entidad.';
        }
      }, (err: HttpErrorResponse) => {
          console.error('Error ReporteEpicrisis.getEntidadEmpresarial()', err);
          this.entidadEmpresarial = null;
          this.mensajeLoading = null;
          // tslint:disable-next-line: max-line-length
          this.mensajeError = 'Error al obtener información de la entidad empresarial, verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.';
      });
    } catch (e) {
        console.error('Catch ReporteEpicrisis.getEntidadEmpresarial()', e);
        this.entidadEmpresarial = null;
        this.mensajeLoading = null;
        this.mensajeError = 'Error grave al obtener información de la entidad empresarial, intente de nuevo. De lo contrario reporte caso al administrador.';
    }
  }

  async getInformacionAfiliado() {
    try {
      this.mensajeLoading = 'Cargando información de historia clínica ...';
      const response = await this.servicioEpicrisis.getInformacionAfiliado(this.objectEpicrisis);
      response.subscribe((data: EpicrisisInformacionAfiliado) => {
        if (data) {
          this.informacionAfiliado = data;
          this.getInformacionEpicrisis();
        } else {
          this.mensajeLoading = null;
          // tslint:disable-next-line: max-line-length
          this.mensajeError = 'Al parecer no existe epicrisis con los datos generados, por favor vuelva a generar el reporte desde el aplicativo Standard Health. De lo contrario reporte caso al administrador';
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteEpicrisis.getInformacionAfiliado()', err);
        this.informacionAfiliado = null;
        this.mensajeLoading = null;
        this.mensajeError = 'Error al obtener información de la historia clínica,verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.';
      });
    } catch (e) {
        console.error('Catch ReporteEpicrisis.getInformacionAfiliado()', e);
        this.informacionAfiliado = null;
        this.mensajeLoading = null;
        this.mensajeError = 'Error grave al obtener información de la historia clínica, intente de nuevo. De lo contrario reporte caso al administrador.';
    }
  }

  async getInformacionEpicrisis() {
    try {
      this.mensajeLoading = 'Cargando información de la epicrisis ...';
      const response = await this.servicioEpicrisis.getCuerpoEpicrisis(this.objectEpicrisis);
      response.subscribe((data: EpicrisisCuerpo[]) => {
        this.informacionEpicrisis = data;
        this.getFirmaProfesional();
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteEpicrisis.getInformacionEpicrisis()', err);
        this.informacionEpicrisis = null;
        this.mensajeLoading = null;
        this.mensajeError = 'Error al obtener información de la epicrisis,verifique conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.';
      });
    } catch (e) {
        console.error('Catch ReporteEpicrisis.getInformacionEpicrisis()', e);
        this.informacionEpicrisis = null;
        this.mensajeLoading = null;
        this.mensajeError = 'Error grave al obtener información de la historia clínica, intente de nuevo. De lo contrario reporte caso al administrador.';
    }
  }

  async getFirmaProfesional() {
    try {
      this.firmaProfesional = '';
      this.mensajeLoading = 'Cargando información del profesional ...';
      const response = await this.servicioImagenes.getFirmaProfesional(this.objectEpicrisis.codigo, this.informacionAfiliado.uncoProfesional);
      response.subscribe((data: any) => {
        this.firmaProfesional = data.source;
        this.mensajeLoading = null;
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteEpicrisis.getFirmaProfesional()', err);
        this.firmaProfesional = null;
        this.mensajeLoading = null;
        this.mensajeError = 'Error al obtener información del profesional, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.';
      });
    } catch (e) {
      console.error('Catch ReporteEpicrisis.getFirmaProfesional()', e);
      this.firmaProfesional = null;
      this.mensajeLoading = null;
      this.mensajeError = 'Error grave al obtener información del profesional, intente de nuevo o reporte caso al administrador.';
    }
  }

  isAvailable(): boolean {
    return this.objectEpicrisis && this.logo
      && this.entidadEmpresarial && this.entidadEmpresarial.unco && this.entidadEmpresarial.unco > 0
      && this.informacionAfiliado != null
      && this.informacionEpicrisis && this.informacionEpicrisis.length > 0;
  }

  isAvailableProfesional(): boolean {
    return this.getProfesional() !== null;
  }

  getFechaIngreso(): number {
    if (this.informacionEpicrisis && this.informacionEpicrisis.length > 0) {
      return this.informacionEpicrisis[0].fechaIngreso;
    }
    return null;
  }

  getFechaEgreso(): number {
    if (this.informacionEpicrisis && this.informacionEpicrisis.length > 0) {
      return this.informacionEpicrisis[0].fechaEgreso;
    }
    return null;
  }

  getPuntoEntrada(): string {
    if (this.informacionEpicrisis && this.informacionEpicrisis.length > 0) {
      return this.informacionEpicrisis[0].puntoAtencionEntrada;
    }
    return '';
  }

  getPuntoSalida(): string {
    if (this.informacionEpicrisis && this.informacionEpicrisis.length > 0) {
      return this.informacionEpicrisis[0].puntoAtencionSalida;
    }
    return '';
  }

  getTextoSoat(): string {
    if (this.informacionEpicrisis && this.informacionEpicrisis.length > 0) {
      return this.informacionEpicrisis[0].textST;
    }
    return '';
  }

  getCausaSalida(): string {
    if (this.informacionEpicrisis && this.informacionEpicrisis.length > 0) {
      return this.informacionEpicrisis[0].causaSalida;
    }
    return '';
  }

  getProfesional(): any {
    if (this.profesional && this.profesional.unco && this.profesional.unco > 0) {
      return this.profesional;
    } else {
      if (this.informacionEpicrisis && this.informacionEpicrisis.length > 0 ) {
        for (let i = 0; i < this.informacionEpicrisis.length; i ++ ) {
          const epc = this.informacionEpicrisis[i];
          if (epc.uncoProfesional && epc.uncoProfesional > 0) {
            this.profesional = {
              unco : epc.uncoProfesional,
              nombreCompleto : epc.profesionalEpicrisis,
              especialidad : epc.especialidadMedico,
              registro : epc.registroMedico
            };
            return this.profesional;
          }
        }
      }
    }
    return this.profesional = null;
  }



}
